import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type {
  AcceptProgramInvitationRequest,
  CreateProgramInvitationRequest,
} from '@coursera/grpc-types-enterpriseuser/coursera/proto/enterpriseuser/programinvitations/v1/program_invitations_api';

const PROGRAM_INVITATIONS_GRPC_ROOT_URL = '/api/grpc/enterpriseuser/programinvitations/v1/ProgramInvitationsAPI';

const programsApi = API('/api/enterprisePrograms.v1', { type: 'rest' });
const programEnrollmentsApi = API('/api/programEnrollments.v2', {
  type: 'rest',
});
const programMembershipsApi = API('/api/programMemberships.v2', {
  type: 'rest',
});
const enterpriseSettingsApi = API('/api/enterpriseSettings.v1', { type: 'rest' });
const thirdPartyOrganizationsApi = API('/api/thirdPartyOrganizations.v1', { type: 'rest' });

const postToProgramInvitations = (endpoint: string, body: any) => {
  return fetch(`${PROGRAM_INVITATIONS_GRPC_ROOT_URL}/${endpoint}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const acceptProgramInvitation = (invitationId: $TSFixMe, userId: $TSFixMe) => {
  const request: AcceptProgramInvitationRequest = {
    programInvitationId: invitationId,
    userId,
  };

  return postToProgramInvitations('AcceptProgramInvitation', request);
};

export const fetchProgramBySlug = (slug: $TSFixMe) => {
  const uri = new URI().addQueryParam('q', 'slug').addQueryParam('slug', slug);

  return Q(programsApi.get(uri.toString()));
};

export const enroll = (action: $TSFixMe, programId: $TSFixMe, itemId: $TSFixMe, userId: $TSFixMe) => {
  const actionToTypeMap = {
    enrollInCourse: 'courseId',
    enrollInS12n: 's12nId',
  };
  const uri = new URI()
    .addQueryParam('action', action)
    .addQueryParam('programId', programId)
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .addQueryParam(actionToTypeMap[action], itemId)
    .addQueryParam('userId', userId);

  return Q(programEnrollmentsApi.post(uri.toString()));
};

export const deleteProgramMembership = (membershipId: $TSFixMe) => {
  const uri = new URI().setPath(membershipId);
  return programMembershipsApi.delete(uri.toString());
};

export const applySetting = (settingId: $TSFixMe, value: $TSFixMe, typeName: $TSFixMe, orgId: $TSFixMe) => {
  const body = {
    data: {
      setting: {
        typeName,
        definition: {
          value,
        },
      },
      thirdPartyOrganizationId: orgId,
    },
  };
  return Q(enterpriseSettingsApi.put(settingId, body));
};

export const deleteSetting = (settingId: $TSFixMe) => {
  return Q(enterpriseSettingsApi.delete(settingId));
};

export const sendProgramInvitation = (programId: $TSFixMe, email: $TSFixMe, name: $TSFixMe) => {
  const request: CreateProgramInvitationRequest = {
    programId,
    invitee: {
      name,
      email,
    },
  };

  return postToProgramInvitations('CreateProgramInvitation', request);
};

const setOrganizationIsReal = (organizationId: $TSFixMe, isReal: $TSFixMe) => {
  const url = new URI()
    .addQueryParam('action', 'setIsReal')
    .addQueryParam('isReal', isReal.toString())
    .addQueryParam('id', organizationId)
    .toString();
  return Q(thirdPartyOrganizationsApi.post(url));
};

export const setOrganizationAsReal = (organizationId: $TSFixMe) => {
  return setOrganizationIsReal(organizationId, true);
};

export const setOrganizationAsFake = (organizationId: $TSFixMe) => {
  return setOrganizationIsReal(organizationId, false);
};

export const downloadOrgMetadata = async (organizationId: $TSFixMe) => {
  const url = new URI().addQueryParam('action', 'getMetadataUploadUrl').addQueryParam('id', organizationId).toString();
  const data = await Q(thirdPartyOrganizationsApi.post(url));
  window.open(data.url.split('?')[0]);
};

export const createOrganization = (body: $TSFixMe) => {
  return Q(thirdPartyOrganizationsApi.post('', { data: body }));
};
